import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'antd';
import { CategoryComponents } from '@app/components/header/components/HeaderSearch/HeaderSearch';
import * as S from './SearchFilter.styles';

interface SearchFilterProps {
  data: CategoryComponents[] | null;
  isVisible: boolean;
  children: (filteredResults: CategoryComponents[]) => React.ReactNode;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
  data,
  isVisible,
  children,
}) => {
  const [selectedFilter, setSelectedFilter] = useState<string[]>([]);
  const [filteredResults, setFilteredResults] = useState<
    CategoryComponents[] | null
  >(data);

  const filterElements = useMemo(() => {
    if (!data?.length) return [];
    return data.map((group) => (
      <Col key={group.category} xs={12} sm={8} md={12} xl={8}>
        <S.CheckBox value={group.category}>{group.category}</S.CheckBox>
      </Col>
    ));
  }, [data]);

  useEffect(() => {
    if (data) {
      if (selectedFilter.length > 0) {
        setFilteredResults(
          data.filter((component) =>
            selectedFilter.some((filter) => filter === component.category)
          )
        );
      } else {
        setFilteredResults(data);
      }
    } else {
      setFilteredResults(null);
    }
  }, [data, selectedFilter]);

  return (
    <>
      <S.FilterWrapper isVisible={isVisible}>
        <S.CheckboxGroup
          onChange={(checkedValues) =>
            setSelectedFilter(checkedValues as string[])
          }
        >
          <Row>{filterElements}</Row>
        </S.CheckboxGroup>
      </S.FilterWrapper>

      {filteredResults && children(filteredResults)}
    </>
  );
};
